import { MenuBoardDataSlice } from '../store/dataSlice';

type MenuBoardDraftData = {
  board: MenuBoardDataSlice['board'];
  sorted: MenuBoardDataSlice['sorted'];
};

export const MenuBoardDraft = {
  Set: (menuId: string, { sorted, board }: MenuBoardDraftData, callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return localStorage.setItem(`MenuBoard-${menuId}`, JSON.stringify({ board, sorted }));
  },
  Get: (menuId: string, callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return JSON.parse(localStorage.getItem(`MenuBoard-${menuId}`) || 'null') as MenuBoardDraftData | null;
  },
  Delete: (menuId: string, callbackFn?: () => void) => {
    callbackFn && callbackFn();
    return localStorage.removeItem(`MenuBoard-${menuId}`);
  },
};
